// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { xScreen } from "@conklin/XDL/Utilities";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface CheckoutSharedStyles {
    container?: InjectableCss;
    containerTitle?: TypographyPresentationProps;
    section?: InjectableCss;
    sectionTitle?: TypographyPresentationProps;
    sectionTitleLink?: LinkPresentationProps;
    editLink?: LinkPresentationProps;
    sectionValue?: TypographyPresentationProps;
}

const checkoutSharedStyles: CheckoutSharedStyles = {
    container: {
        css: css`
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 24px 154px;

            ${xScreen("lte", "lg")} {
                gap: 24px 135px;
            }

            ${xScreen("lte", "md")} {
                grid-template-columns: 1fr;
            }

            @media print {
                margin-bottom: 8px;
            }
        `,
    },
    containerTitle: {
        variant: "h3",
        css: css`
            grid-column: 1/3;
        `,
    },
    section: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        `,
    },
    sectionTitle: {
        variant: "h6",
        css: css`
            margin-bottom: 8px;
        `,
    },
    sectionTitleLink: {
        typographyProps: {
            size: 12,
            lineHeight: "15px",
            css: css`
                &&& {
                    line-height: 15px;
                }
            `,
        },
        css: css`
            margin-left: 24px;
        `,
    },
    editLink: {
        typographyProps: {
            size: 12,
            lineHeight: "15px",
            css: css`
                &&& {
                    line-height: 15px;
                }
            `,
        },
        css: css`
            margin-top: 12px;
        `,
    },
    sectionValue: {
        variant: "h6",
        weight: fontConfig.weight.regular,
        css: css`
            display: flex;
            align-items: center;
            > div {
                display: inline-flex;
            }
            margin-bottom: 0;
        `,
    },
};

export default checkoutSharedStyles;
